import { strCode } from "../../../../consts";

export const metricsConfig = {
  regular: {
    id: "regular",
    name: strCode.REGULAR_SEGMENT_TITLE,
    color: "#49937C"
  },

  chilled: {
    id: "chilled",
    name: strCode.CHILLED_SEGMENT_TITLE,
    color: "#B78FD6"
  },
  mild: {
    id: "mild",
    name: strCode.MILD_SEGMENT_TITLE,
    color: "#404FCF"
  },
  sprint: {
    id: "sprint",
    name: strCode.SPRINT_SEGMENT_TITLE,
    color: "#50CAF6"
  },
  alert: {
    id: "alert",
    name: strCode.ALERT_SEGMENT_TITLE,
    color: "#F2A65A"
  }
};

export const metricsDescription = {
  regular: strCode.REGULAR_SEGMENT_DESCRIPTION,
  chilled: strCode.CHILLED_SEGMENT_DESCRIPTION,
  mild: strCode.MILD_SEGMENT_DESCRIPTION,
  sprint: strCode.SPRINT_SEGMENT_DESCRIPTION,
  alert: strCode.ALERT_SEGMENT_DESCRIPTION
};
